import Vue from "vue"

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.application
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {
    setApplication(state, data) {
        Vue.set(this.state.appStore, 'application', {...this.state.appStore.application, ...data})
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    set({ commit, dispatch, rootState }, application) {
        return new Promise((resolve, reject) => {
            if (typeof application !== "undefined") {
                commit("setApplication", application)
                dispatch("appStore/application/applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                dispatch("appStore/application/approved_loan_applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                resolve(application)
            } else {
                $tenant
                    .post(`/admin/application/get-application`, {
                        applicationId: rootState.appStore.application.application.id
                    })
                    .then((res) => {
                        commit("setApplication", res.data)
                        dispatch("appStore/application/applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                        dispatch("appStore/application/approved_loan_applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
                    .finally(() => {

                    })
            }
        })
    },
    update({ commit, dispatch, rootState }, application) {
        return new Promise((resolve, reject) => {
            $tenant
                .post(`/admin/application/${rootState.appStore.application.id}/update-application`, {
                    application: application
                })
                .then((res) => {
                    commit("setApplication", res.data)
                    dispatch("appStore/application/applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                    dispatch("appStore/application/approved_loan_applicants/setActive", rootState.appStore.application.active_applicant, { root: true })
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
                .finally(() => {

                })
        })
    }
}

export default {
    namespaced: true,
    namespace: "application",
    modules: getModules('application'),
    state: {},
    getters,
    mutations,
    actions
}
